import { FormControl, ValidatorFn, ValidationErrors } from "@angular/forms";
import { RegexValidator } from "./regex-validator.function";

export function DecimalValidator(integerPlaces: number, decimalPlaces: number): ValidatorFn {

    const regex = "^(?!\\.?$)\\d{0," + integerPlaces + "}(\\.\\d{1," + decimalPlaces + "})?$";
    
    return (control: FormControl): ValidationErrors | null => {
        return RegexValidator(control, regex, "format", "fieldValidation.notValidFormat");
    }
}
